module.exports = __webpack_public_path__ + "assets/img/home_b2.986fac70.png";